import axios from 'axios';


const service = axios.create({
  baseURL: '',
  timeout: 10000,
});
/* eslint no-param-reassign: ["error", { "props": false }] */
service.interceptors.request.use((config) => {
  if (service.defaults.baseURL.length < 1) {
    config.baseURL = localStorage.getItem('baseURL');
  }
  if (config.headers.usepso) {
    delete config.headers.usepso;
  }
  return config;
}, (error) => {
  Promise.reject(error);
});

export default service;
